import clsx from 'clsx';
import React from 'react';

import ShipLoading from './ShipLoading';

interface LoaderProps {
  outerClassName?: string;
  darkMode?: boolean; // optional: force dark mode styling
}

const Loader = ({ outerClassName, darkMode = false }: LoaderProps) => {
  return (
    <div className={clsx('flex items-center justify-center h-screen', outerClassName)}>
      <ShipLoading fullScreen={false} size="md" label="" />
    </div>
  );
};

export default Loader;
